import { Box, Typography } from "@mui/material"
import type { FC } from "react"

interface ShipToLocation {
  name?: string | null
  city?: string | null
  regionIsoCode?: string | null
}

interface ShipToLocationCellProps {
  location?: ShipToLocation | null
}

export const ShipToLocationCell: FC<ShipToLocationCellProps> = ({ location }) => {
  if (!location) return <Typography variant='body2'>-</Typography>

  const cityRegion = [location.city, location.regionIsoCode].filter(Boolean).join(", ")

  return (
    <Box className='flex flex-col gap-0.5'>
      <Typography variant='body2' className='font-medium'>
        {location.name}
      </Typography>
      {cityRegion && <Typography variant='body2'>{cityRegion}</Typography>}
    </Box>
  )
}
